<template>

    <div v-if="!paymentModal" class="price__heading">
        <div class="price__heading-box">
            <BackButton class="back-button"/>
            <h2 class="mb0 h1">{{ $t('general.buy_credits') }}</h2>
        </div>

        <div class="u-text-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="300" class="mb mt" version="1.0" viewBox="0 0 810 487.5"><defs><clipPath id="a"><path d="M.414 0h809.172v331H.414Zm0 0"/></clipPath></defs><g clip-path="url(#a)"><path fill="none" stroke="#fff" stroke-width="13.085443999999999" d="M27.078 251.605h76.5c53.16 0 73.266-11.757 73.266-41.746v-42.082c0-14.652-6.133-26.75-19.594-31.863 13.46-5.281 17.55-17.207 17.55-32.031V61.629c0-29.988-19.937-41.742-73.093-41.742H27.078Zm69.516-132.898V61.289h3.75c4.77 0 5.96 1.875 5.96 7.836v41.234c0 6.301-1.87 8.348-6.644 8.348Zm0 91.324v-57.078h3.066c4.774 0 6.645 2.043 6.645 8.348v41.062c0 5.793-1.192 7.668-5.961 7.668Zm88.258 41.574H290.66V200.32h-32.715V19.887h-73.093Zm195.43 0h72.921l-41.23-231.718h-77.356l-41.23 231.718h73.261l.852-26.238h11.758Zm-11.419-64.918 2.899-88.425h2.382l3.579 88.425Zm167.996 69.348c51.625 0 78.887-24.195 80.25-70.879v-44.3h-75.476v50.773c0 3.238-1.707 4.941-4.774 4.941-3.234 0-4.941-1.703-4.941-4.941V79.348c0-3.239 1.707-4.942 4.941-4.942 3.067 0 4.774 1.703 4.774 4.942v51.285l75.476-.168V86.164c-1.191-46.684-28.453-70.707-80.25-70.707-52.816 0-80.078 24.875-80.078 73.434v93.367c0 48.73 27.262 73.777 80.078 73.777Zm88.09-4.43h73.094l-1.196-90.984h3.75l7.836 90.984h77.524l-19.934-115.859 19.082-115.86h-76.84l-7.668 93.368h-3.75l1.196-93.367h-73.094Zm0 0"/></g><path fill="#d3001a" d="m26.306 476.359 66.485-.156v-73.766h30.375v-43.082H92.79v-49.898h37.656V265.6H26.307ZM272.554 476.359l-13.015-82.754c8.058-6.664 12.707-16.738 12.707-31.77v-46.492c0-42.304-28.207-49.742-69.582-49.742h-65.09V476.36h63.23v-70.355h5.735l3.254 70.355Zm-71.75-105.535V310.23h3.41c4.336 0 5.422 1.707 5.422 6.977v46.336c0 5.578-1.394 7.28-5.113 7.28ZM279.525 476.359h66.485V265.601h-66.485ZM354.065 476.359h69.118c47.113 0 71.441-21.695 71.441-63.691v-83.532c0-41.996-24.328-63.535-71.594-63.535h-68.965Zm64.317-51.762V317.672h3.562c4.649 0 5.27 2.167 5.27 11.777v83.527c0 9.297-.621 11.621-5.27 11.621ZM576.604 476.359h66.328l-37.504-210.758h-70.356L497.568 476.36h66.637l.774-23.867h10.695Zm-10.383-59.043 2.633-80.43h2.171l3.254 80.43ZM682.291 476.359h66.637l-.309-66.016 39.672-144.742h-68.344l-3.253 94.531-2.477.153-4.496-94.684h-67.102l39.672 145.051Zm0 0"/></svg>
            <div class="o-flex o-flex--center o-flex--justify-center">
                <img :src="`../../../img/black-friday/${auth.user.lang.toUpperCase()}.svg`" class="mr" width="100" alt="badge">
                <p class="u-text-center clr-white mb0">{{$t('promotions.hurry_up')}} <br>
                    <span class="o-flex o-flex--center">
                        <svg class="mr- clock" xmlns="http://www.w3.org/2000/svg" width="17" height="20"
                                viewBox="0 0 17.143 20">
                            <path fill="#fff"
                                    d="M11.429 0H5.714v1.9h5.714Zm-3.81 12.381h1.9V6.667h-1.9Zm7.648-6.3 1.352-1.352a10.522 10.522 0 0 0-1.343-1.339l-1.352 1.353a8.571 8.571 0 1 0 1.343 1.343Zm-6.7 12.01a6.667 6.667 0 1 1 6.667-6.667A6.662 6.662 0 0 1 8.571 18.1Z"
                                    data-name="Icon material-timer"/>
                        </svg>
                        {{ timeRemaining }}
                    </span></p>
            </div>
        </div>

    </div>

    <div v-else>
        <div v-if="!promotion.template === 'black_friday_50'" class="amount-box">
            <img src="../../assets/img/dollar-icon.svg" alt="Dollar icon"> {{credits}}
        </div>
        <h2 v-if="!promotion.template === 'black_friday_50'" class="h4">{{$t('credits.not_enough_credits')}}? {{$t('credits.recharge')}}:</h2>
        <div v-else class="o-flex o-flex--center o-flex--justify-center">
            <img :src="`../../../img/black-friday/${auth.user.lang.toUpperCase()}.svg`" class="mr-" width="50" alt="badge">
            <p class="u-text-center mb0">{{$t('promotions.hurry_up')}} <br>
                <span class="o-flex o-flex--center">
                    <svg class="mr- clock" xmlns="http://www.w3.org/2000/svg" width="17" height="20"
                         viewBox="0 0 17.143 20">
                        <path fill="#000"
                              d="M11.429 0H5.714v1.9h5.714Zm-3.81 12.381h1.9V6.667h-1.9Zm7.648-6.3 1.352-1.352a10.522 10.522 0 0 0-1.343-1.339l-1.352 1.353a8.571 8.571 0 1 0 1.343 1.343Zm-6.7 12.01a6.667 6.667 0 1 1 6.667-6.667A6.662 6.662 0 0 1 8.571 18.1Z"
                              data-name="Icon material-timer"/>
                    </svg>
                    {{ timeRemaining }}
                </span>
            </p>
        </div>

    </div>
</template>
<script>
import BackButton from "@/components/generic/BackButton.vue";
import ThemeMixin from "@/mixins/ThemeMixin";
import { mapState } from "vuex";
import moment from "moment";

import { daysHoursMinutesSecondsSince } from "@/utilities/general";
import AuthenticatedMixin from "@/mixins/AuthenticatedMixin";
export default {
    name: "BlackFriday50Header",
    components: { BackButton },
    mixins: [ThemeMixin, AuthenticatedMixin],
    props: {
        promotion: {
            type: Object
        },
        paymentModal: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            timeRemainingInterval: null,
            timeRemaining: '',
            daysLeft: 0,
            days: 0,
            validUntil: null
        }
    },
    computed: {
        ...mapState({
            credits: state => state.credits.amount
        })
    },
    methods: {
        async setDynamicValues(end)
        {
            this.timeRemaining = daysHoursMinutesSecondsSince(moment.utc(), end)

            this.daysLeft = parseInt(this.timeRemaining.split(':')[0])
        }
    },
    mounted() {

        this.validUntil = moment.utc(this.promotion.valid_until)

        if(this.validUntil) {

            this.setDynamicValues(this.validUntil)

            this.timeRemainingInterval = setInterval(() => {
                this.setDynamicValues(this.validUntil)
            }, 1000)

        }

    },
    beforeUnmount() {
        clearInterval(this.timeRemainingInterval)
    },
    created() {
        this.conversation_price = process.env.VUE_APP_UNLOCK_CONVERSATION
    }
}

</script>
<style scoped lang="scss">
    .price__heading {
        text-align: left;

        h2 {
            margin-bottom: 10px;
            font-weight: 700;
        }

        p {
            font-size: 18px;
            line-height: 24px;
        }

        @media(max-width: 991px) {
            padding: 0 20px;

            p {
                margin-bottom: 0;
                font-size: 16px;
                line-height: 19px;
                letter-spacing: 0.06px;
            }
        }
    }

    .price__heading-box {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .back-button {
            margin-right: 20px;
            display: none;
        }

        @media(max-width: 991px) {
            margin-bottom: 25px;

            .back-button {
                display: flex;
            }
        }
    }

    .amount-box {
        border-radius: 15px;
        background-color: #fff;
        padding-left: 40px;
        position: relative;
        display: inline-flex;
        align-items: center;
        font-weight: 700;
        height: 30px;
        width: auto;
        padding-right: 20px;
        margin-bottom: 10px;
        font-size: 18px;
        font-family: "Open Sans", sans-serif!important;

        img {
            position: absolute;
            top: 0;
            left: 0;
        }

        @media(max-width: 350px) {
            min-width: 105px;
        }
    }
</style>

